export const SET_PATCHING_FILTERS = 'SET_PATCHING_FILTERS';
